var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"pr-2"},[_c('BackToProposal')],1),_c('div',{staticClass:"service-edit"},[_c('ServicesEdit')],1),_c('div',{staticClass:"toolbar px-5"},[_c('ToolBar',{staticClass:"toolbar-stick"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }